import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import {
	$deleteEnvironment,
	$environmentNames,
	$environmentText,
	$environmentVars,
	$environmentsInfo,
	$selectedEnvironmentName,
	$selectedEnvironmentVars,
	$writeEnvironmentText,
} from "../../internal/environments";

export const useEnvironments = () => {
	const environmentNamesLoadable = useAtomValue(loadable($environmentNames));
	const selectedNameLoadable = useAtomValue(loadable($selectedEnvironmentName));
	const selectedVarsLoadable = useAtomValue(loadable($selectedEnvironmentVars));

	const selectEnvironment = useSetAtom($selectedEnvironmentName);
	const refreshEnvironmentsInfo = useSetAtom($environmentsInfo);
	const deleteEnvironment = useSetAtom($deleteEnvironment);
	const writeEnvironmentText = useSetAtom($writeEnvironmentText);

	const createEnvironment = async (name: string) => {
		await writeEnvironmentText({ name, text: "" });
	};

	return {
		environmentNames:
			environmentNamesLoadable.state === "hasData" ? environmentNamesLoadable.data : [],
		selectedEnvironmentName:
			selectedNameLoadable.state === "hasData" ? selectedNameLoadable.data : null,
		selectedEnvironmentVars:
			selectedVarsLoadable.state === "hasData" ? selectedVarsLoadable.data : {},
		isLoading:
			environmentNamesLoadable.state === "loading" ||
			selectedNameLoadable.state === "loading",
		selectEnvironment,
		refreshEnvironmentsInfo,
		createEnvironment,
		writeEnvironmentText,
		deleteEnvironment,
	};
};

export const useEnvironmentVars = (name: string) => {
	const varsLoadable = useAtomValue(loadable($environmentVars(name)));

	return {
		vars: varsLoadable.state === "hasData" ? varsLoadable.data : {},
		isLoading: varsLoadable.state === "loading",
	};
};

export const useEnvironmentsInfo = () => {
	const infosLoadable = useAtomValue(loadable($environmentsInfo));

	return {
		infos: infosLoadable.state === "hasData" ? infosLoadable.data : [],
		isLoading: infosLoadable.state === "loading",
	};
};

export const useEnvironmentText = (name: string) => {
	const textLoadable = useAtomValue(loadable($environmentText(name)));
	const writeTextAtom = useSetAtom($writeEnvironmentText);

	const writeText = async (text: string) => {
		await writeTextAtom({ name, text });
	};

	return {
		text: textLoadable.state === "hasData" ? textLoadable.data : "",
		isLoading: textLoadable.state === "loading",
		writeText,
	};
};
